/**
 * The API tokens of the signed-in user.
 *
 * The tokens screen and the settings tab strip read the same list, so the
 * query lives here and both use the same key — one request, one cache entry.
 */

import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'
import type { ApiToken } from '@friday/shared/realtime'

export function useApiTokens() {
  return useQuery({
    queryKey: ['me', 'api-tokens'],
    queryFn: () => api<ApiToken[]>('/api/v1/me/api-tokens'),
  })
}

/** How many tokens are still usable. Revoked ones do not count. */
export function activeTokenCount(tokens: ApiToken[] | undefined): number {
  return (tokens ?? []).filter((t) => !t.revokedAt).length
}
